// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"rC-z","expressButtonContainerWithPayPal":"sC-z","expressButton":"tC-z","or":"uC-z"};